<template>

    <div
        class="min-h-screen grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 gap-0 bg-gradient-to-b from-blueberry1 to-blueberry2 relative">


        <div
            class="flex flex-col flex-grow items-center lg:items-end justify-center min-h-screen p-4 sm:py-12 sm:pl-12 sm:pr-12 md:pr-0 col-span-1 md:col-span-2 lg:col-span-1">

            <inertia-link :href="'/'"
                class="flex md:hidden w-full flex-shrink justify-center items-center pb-10 pt-6 sm:pt-0">
                <img src="/img/birdie_nova.svg" alt="Logo" class="w-32 sm:w-40 h-auto" />
            </inertia-link>

            <div
                class="flex flex-col flex-grow w-full px-6 pt-10 sm:pt-4 pb-4 max-w-xl bg-white shadow-md overflow-hidden rounded-lg justify-start sm:justify-center">


                <div class="mx-auto w-full max-w-sm flex-grow flex flex-col justify-center mt-10">

                    <h1 v-if="integration_type == ''"
                        class="font-bold text-3xl text-birdie-grey-medium text-center font-jakarta">Welcome
                        to
                        Birdie 👋
                    </h1>

                    <div v-else class="hidden lg:flex w-full flex-col
                    justify-center px-4 gap-y-4">

                        <h3 v-if="integration_type == 'intercom'"
                            class="text-birdie-dark flex flex-row justify-center items-center gap-x-3">
                            <img src="/img/logo-black-website.svg" width="110" alt="Logo" class="" />
                            <span class="text-birdie-dark font-bold text-2xl uppercase">+</span>
                            <img src="/img/intercom-full-dark.svg" width="160" alt="Intercom Logo"
                                class="intercom-logo" />
                        </h3>

                        <h3 v-else-if="integration_type == 'zendesk'"
                            class="text-birdie-dark flex flex-row justify-center items-center gap-x-3">
                            <img src="/img/logo-black-website.svg" width="110" alt="Logo" class="" />
                            <span class="text-birdie-dark font-bold text-2xl uppercase">+</span>
                            <img src="/img/zendesk-full-dark.svg" width="140" alt="Zendesk Logo" class="zendesk-logo"
                                style="margin-top:-6px;" />
                        </h3>

                        <h3 v-else-if="integration_type == 'aircall'"
                            class="text-birdie-dark flex flex-row justify-center items-center gap-x-3">
                            <img src="/img/logo-black-website.svg" width="110" alt="Logo" class="" />
                            <span class="text-birdie-dark font-bold text-2xl uppercase">+</span>
                            <img src="/img/aircall_logo.svg" width="120" alt="Aircall Logo" class="aircall-logo" />
                        </h3>

                        <h3 v-else-if="integration_type == 'helpscout'"
                            class="text-birdie-dark flex flex-row justify-center items-center gap-x-3">
                            <img src="/img/logo-black-website.svg" width="110" alt="Logo" class="" />
                            <span class="text-birdie-dark font-bold text-2xl uppercase">+</span>
                            <img src="/img/helpscout-logo.svg" width="140" alt="Helpscout Logo" class="helpscout-logo"
                                style="margin-top:0" />
                        </h3>

                        <h3 v-else-if="integration_type == 'freshchat'"
                            class="text-birdie-dark flex flex-row justify-center items-center gap-x-3">
                            <img src="/img/logo-black-website.svg" width="110" alt="Logo" class="" />
                            <span class="text-birdie-dark font-bold text-2xl uppercase">+</span>
                            <img src="/img/freshchat-logo.svg" width="140" alt="Freshchat Logo"
                                class="freshchat-logo" />
                        </h3>

                        <h3 v-else-if="integration_type == 'freshdesk'"
                            class="text-birdie-dark flex flex-row justify-center items-center gap-x-3">
                            <img src="/img/logo-black-website.svg" width="110" alt="Logo" class="" />
                            <span class="text-birdie-dark font-bold text-2xl uppercase">+</span>
                            <img src="/img/freshdesk-logo.svg" width="140" alt="Freshdesk Logo"
                                class="freshdesk-logo" />
                        </h3>

                        <h3 v-else-if="integration_type == 'jira'"
                            class="text-birdie-dark flex flex-row justify-center items-center gap-x-3">
                            <img src="/img/logo-black-website.svg" width="110" alt="Logo" class="" />
                            <span class="text-birdie-dark font-bold text-2xl uppercase">+</span>
                            <img src="/img/jsm-logo.svg" width="35" alt="Jira Logo" class="jira-logo" />
                        </h3>

                        <p class="text-center text-gray-700 text-sm">Empower your team to request screen recordings and
                            resolve issues faster—all from your helpdesk.</p>
                    </div>




                    <jet-banner />

                    <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
                        {{ status }}
                    </div>

                    <form @submit.prevent="submit" class="pt-5">

                        <transition name="fade2">
                            <div v-if="invitation"
                                class="flex items-center justify-center my-5 text-birdie-blue font-bold">
                                Join {{ invitation.team.name }} Workspace
                            </div>
                            <div v-else-if="invitation_link_team_name"
                                class="flex items-center justify-center my-5 text-birdie-blue font-bold">
                                Join {{ invitation_link_team_name }} Workspace
                            </div>
                            <div class="gblock" v-else-if="!sso_redirect && !form.google_id">
                                <div class="flex items-center justify-end mt-4" style="height: 42px;">
                                    <a :href="route('google.auth')" title="Use your Google account"
                                        class="relative flex flex-row overflow-hidden w-full items-center bg-blue-500 border-2 border-blue-500 rounded-md font-semibold text-sm text-white uppercase tracking-widest hover:bg-blue-400 hover:border-blue-400 active:bg-blue-600 focus:outline-none focus:border-blue-600 focus:ring focus:ring-blue-400 disabled:opacity-25 transition">
                                        <div
                                            class=" absolute left-0 h-full bg-white text-blue-500 w-12 flex items-center justify-center">
                                            <svg viewBox="0 0 24 24" class="w-5 h-5" xmlns="http://www.w3.org/2000/svg">
                                                <g transform="matrix(1, 0, 0, 1, 27.009001, -39.238998)">
                                                    <path fill="#4285F4"
                                                        d="M -3.264 51.509 C -3.264 50.719 -3.334 49.969 -3.454 49.239 L -14.754 49.239 L -14.754 53.749 L -8.284 53.749 C -8.574 55.229 -9.424 56.479 -10.684 57.329 L -10.684 60.329 L -6.824 60.329 C -4.564 58.239 -3.264 55.159 -3.264 51.509 Z" />
                                                    <path fill="#34A853"
                                                        d="M -14.754 63.239 C -11.514 63.239 -8.804 62.159 -6.824 60.329 L -10.684 57.329 C -11.764 58.049 -13.134 58.489 -14.754 58.489 C -17.884 58.489 -20.534 56.379 -21.484 53.529 L -25.464 53.529 L -25.464 56.619 C -23.494 60.539 -19.444 63.239 -14.754 63.239 Z" />
                                                    <path fill="#FBBC05"
                                                        d="M -21.484 53.529 C -21.734 52.809 -21.864 52.039 -21.864 51.239 C -21.864 50.439 -21.724 49.669 -21.484 48.949 L -21.484 45.859 L -25.464 45.859 C -26.284 47.479 -26.754 49.299 -26.754 51.239 C -26.754 53.179 -26.284 54.999 -25.464 56.619 L -21.484 53.529 Z" />
                                                    <path fill="#EA4335"
                                                        d="M -14.754 43.989 C -12.984 43.989 -11.404 44.599 -10.154 45.789 L -6.734 42.369 C -8.804 40.429 -11.514 39.239 -14.754 39.239 C -19.444 39.239 -23.494 41.939 -25.464 45.859 L -21.484 48.949 C -20.534 46.099 -17.884 43.989 -14.754 43.989 Z" />
                                                </g>
                                            </svg>
                                        </div>
                                        <div class="flex flex-grow py-2 ml-3 justify-center"
                                            v-html="is_signup ? 'Sign up with Google' : 'Sign in with Google'">
                                        </div>
                                    </a>
                                </div>

                                <div v-if="!sso_redirect" id="g_id_onload"
                                    data-client_id="387274310925-s61aeo8fem7158h6dp6mpe4mtajpqi5p.apps.googleusercontent.com"
                                    data-auto_select="true" data-login_uri="/google/auth">
                                </div>

                                <div v-if="!sso_redirect">
                                    <div class="pt-9 pb-8">
                                        <div class="border-t border-gray-200 relative flex justify-center">
                                            <div class="absolute bg-white text-gray-300 -mt-3 px-2 text-sm">OR</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition>


                        <div>


                            <div class="relative h-12">

                                <input v-if="!email_disabled" type="email" name="email" id="email"
                                    :class="[is_signup ? 'border-birdie-blue' : '',
                                    email_disabled ? 'text-gray-400 pr-10 ' : 'text-birdie-grey-medium pr-3',
                                        'mt-1 block w-full rounded-md bg-white py-2 px-10 text-base border border-gray-300 focus:outline-0 focus:border-birdie-blue placeholder:text-gray-400 sm:pl-9 sm:text-sm/6 peer']"
                                    ref="emailInput" placeholder=" " v-model="form.email" required
                                    autocomplete="username"
                                    :disabled="email_disabled" />

                                <div v-else
                                    class="text-gray-400 pr-10 mt-1 block w-full rounded-md bg-white py-2 px-10 text-base border border-gray-300 focus:outline-0 focus:border-gray-400 placeholder:text-gray-400 sm:pl-9 sm:text-sm/6 peer">
                                    {{ form.email }}</div>

                                <label for="email" class="absolute top-2 left-3 text-birdie-grey-medium bg-white duration-300 transform -translate-y-4 transparent text-xs font-medium
                                    peer-focus:text-birdie-blue px-2 autofill:bg-white
                                    peer-focus:top-2
                                    peer-focus:left-3
                                    peer-focus:text-xs
                                    peer-focus:font-medium
                                    peer-focus:-translate-y-4
                                    peer-focus:px-2
                                    peer-focus:transparent
                                    peer-placeholder-shown:px-0
                                    peer-placeholder-shown:left-10
                                    peer-placeholder-shown:translate-y-0.5
                                    peer-placeholder-shown:text-gray-300
                                    peer-placeholder-shown:text-base
                                    peer-placeholder-shown:font-normal ">
                                    Work email
                                </label>

                                <EnvelopeIcon
                                    :class="[email_disabled ? 'text-gray-300' : 'text-gray-400', 'absolute left-3 pointer-events-none text-gray-400 w-4 h-4']"
                                    style="top: 0.85rem;" aria-hidden="true" />

                                <XCircleIcon v-if="email_disabled && !form.is_invitemail"
                                    class="absolute right-3 cursor-pointer hover:text-gray-600 text-gray-400 w-4 h-4"
                                    style="top: 0.85rem;" aria-hidden="true" @click.prevent="backToEmail" />

                                <spinner v-if="testing_email" class="absolute right-3 text-gray-400 w-4 h-4"
                                    style="top: 0.85rem;" aria-hidden="true">
                                </spinner>

                                <div v-if="user_error && !user_checked" class="text-red-500 text-sm"
                                    v-html="user_error">
                                </div>

                            </div>


                        </div>






                        <transition name="fade">

                            <div v-if="user_checked && need_code_validation" class="mt-7">

                                <input type="hidden" name="username" :value="form.email"
                                    :class="{ 'text-red-500': hasErrors }" />


                                <div class="">
                                    <div class="relative">

                                        <input type="text" name="code" id="code" :disabled="code_disabled"
                                            class="block w-full rounded-md bg-white px-3 py-2 text-base text-birdie-grey-medium border border-gray-300 focus:outline-0 focus:border-gray-400 placeholder:text-gray-300  sm:text-sm/6 peer"
                                            v-model="form.code" required maxlength="6" minlength="6" ref="codeInput"
                                            @input="codeChanged" placeholder=" " autocomplete="one-time-code" />

                                        <label for="code" class="absolute top-2 left-3 text-birdie-grey-medium bg-white duration-300 transform -translate-y-4 transparent text-xs font-medium
                                    peer-focus:text-birdie-blue px-2 autofill:bg-white
                                    peer-focus:top-2
                                    peer-focus:text-xs
                                    peer-focus:font-medium
                                    peer-focus:-translate-y-4
                                    peer-focus:px-2
                                    peer-focus:transparent
                                    peer-placeholder-shown:px-0
                                    peer-placeholder-shown:translate-y-0
                                    peer-placeholder-shown:text-gray-300
                                    peer-placeholder-shown:text-base
                                    peer-placeholder-shown:font-normal ">
                                            6-digit code
                                        </label>

                                    </div>

                                </div>

                                <div v-if="hasErrors" class="text-red-500 text-sm" v-html="errorString()">
                                </div>

                                <!-- <div v-if="hasErrors">
                                    <div class="font-medium text-red-600">Whoops! Something went wrong.</div>

                                    <ul class="mt-3 list-disc list-inside text-sm text-red-600">
                                        <li v-for="(error, key) in errors" :key="key">{{ error }}</li>
                                    </ul>
                                </div> -->


                                <!-- <jet-validation-errors class="mb-4" /> -->



                                <div class="mt-2 mb-4 flex flex-row justify-between">
                                    <label class="flex items-center">
                                        <span class="ml-0 text-sm text-gray-400">We sent a code to your inbox</span>
                                    </label>

                                    <span v-if="seconds_left == 0" href="#" @click.prevent.stop="timer()"
                                        class="underline text-sm text-gray-600 hover:text-gray-900 cursor-pointer  inline-flex items-center justify-end">
                                        Send again
                                    </span>
                                    <span v-else class="text-sm text-gray-400">
                                        Send again in {{ seconds_left }} seconds
                                    </span>


                                </div>

                            </div>

                        </transition>


                        <div class="flex items-center justify-center mt-6 mb-4" style="height: 42px;">

                            <button type="submit"
                                :class="[button_disabled ? 'opacity-25' : '',
                                is_signup ? 'bg-birdie-blue hover:bg-birdie-blue/80' : 'bg-gray-800 hover:bg-gray-700',
                                    'inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md font-semibold text-white uppercase tracking-widest  focus:outline-none focus:ring focus:ring-gray-300 disabled:opacity-25 disabled:cursor-default transition w-full h-full text-sm']"
                                :disabled="button_disabled" @click.prevent.stop="clickButton">
                                <span v-if="is_signup">Create Free Account</span>
                                <span v-else-if="is_sso">Sign in with SSO</span>
                                <span v-else-if="is_join">Join Your Team's Workspace</span>
                                <span v-else>Continue</span>
                            </button>

                        </div>


                    </form>




                    <!-- <div v-if="!user_checked || !sso_redirect"
                        :class="[email_disabled ? 'opacity-0 pointer-events-none' : 'flex', ' flex-col text-gray-500 bg-transparent rounded-md text-center items-center p-4 text-sm transition-opacity mt-12']">
                        <span>You don’t have an account yet?</span>
                        <inertia-link v-if="form.email && is_not_user"
                            :href="route('letsgo.start', { email: form.email })"
                            class="underline font-bold text-birdie-blue hover:text-gray-900">
                            Sign up now
                        </inertia-link>
                        <inertia-link v-else :href="route('letsgo.start')"
                            class="underline font-bold text-gray-700 hover:text-gray-900">
                            Sign up now
                        </inertia-link>
                    </div> -->



                </div>

                <div class="text-center text-gray-500 text-xs px-5">
                    By signing up, you acknowledge that you have read and understood, <br />and agree to our
                    Birdie’s
                    <a href="https://www.birdie.so/terms" target="_blank" title="Terms of Service"
                        class="text-birdie-blue hover:underline">Terms of
                        Service</a>
                    and
                    <a href="https://www.birdie.so/legal#PrivacyPolicy" target="_blank" title="Privacy Policy"
                        class="text-birdie-blue hover:underline">Privacy Policy</a>
                </div>



            </div>


        </div>


        <div class="hidden md:flex flex-col flex-grow items-center justify-center min-h-screen p-4 ">

            <inertia-link :href="'/'">
                <img src="/img/birdie_nova.svg" alt="Logo" class="w-40 h-auto" />
            </inertia-link>

            <p class="mt-24 text-gray-300 text-sm px-5 md:px-10 lg:px-20 text-center font-medium" style="color:#8499B2">
                Trusted by 2500+
                companies</p>
            <!-- <jet-authentication-card-logo :name="$page.props.app_name.toLowerCase()" /> -->
            <div
                class=" mt-10 text-gray-500 text-xs px-5 md:px-10 lg:px-20 flex flex-wrap gap-x-5 gap-y-6 justify-around items-center">

                <img src="https://cdn.prod.website-files.com/63568f58066d30e2a58c8025/679ab0da2ef5bf946cfb14dd_Microsoft.png"
                    loading="lazy" class="h-8" alt="">
                <img src="https://cdn.prod.website-files.com/63568f58066d30e2a58c8025/679accefb16660fd620b8080_Drata-p-500.png"
                    loading="lazy" class="h-6" alt="">
                <img src="https://cdn.prod.website-files.com/63568f58066d30e2a58c8025/63723ec169a5304de3c16672_Onecom.svg"
                    loading="lazy" class="h-8" alt="">
                <img src="https://cdn.prod.website-files.com/63568f58066d30e2a58c8025/679ad2c8ca2ca8acf29ea0e9_basecamp-logo-p-500.png"
                    loading="lazy" class="h-8" alt="">
                <img src="https://cdn.prod.website-files.com/63568f58066d30e2a58c8025/63723ec2b338426f35aa6167_Pennylane.svg"
                    loading="lazy" class="h-8" alt="">
                <img src="https://cdn.prod.website-files.com/63568f58066d30e2a58c8025/63723ec20641009a659b6927_ai21labs.svg"
                    loading="lazy" class="h-8" alt="">
                <img src="https://cdn.prod.website-files.com/63568f58066d30e2a58c8025/63723ec14ca07b5685acadb9_Holded.svg"
                    loading="lazy" class="h-8" alt="">
                <img src="https://cdn.prod.website-files.com/63568f58066d30e2a58c8025/63723ec10e1e220c8462ecff_Agorapulse.svg"
                    loading="lazy" class="h-8" alt="">
                <img src="https://cdn.prod.website-files.com/63568f58066d30e2a58c8025/679ad1f092f66dee32abdec8_schoox-p-500.png"
                    loading="lazy" class="h-8" alt="">
                <img src="https://cdn.prod.website-files.com/63568f58066d30e2a58c8025/679ab3f0ba11527272573413_Cisco-p-500.png"
                    loading="lazy" class="h-16 -my-5">

            </div>

        </div>

        <extension-pin-overlay v-if="login_landing == 'extension'" @close="closePinOverlay" />

    </div>




</template>

<script>
//import JetAuthenticationCard from '@/Jetstream/AuthenticationCard'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo'
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetCheckbox from '@/Jetstream/Checkbox'
import JetLabel from '@/Jetstream/Label'
//import JetValidationErrors from '@/Jetstream/ValidationErrors'
import JetSectionBorder from '@/Jetstream/SectionBorder'
import JetBanner from '@/Jetstream/Banner'
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/vue/24/outline";
import { EnvelopeIcon, XCircleIcon, LockClosedIcon } from '@heroicons/vue/16/solid'
const CancelToken = axios.CancelToken;
import moment from 'moment-timezone';
let cancel;
import Spinner from '@/Components/UI/Spinner'
import ExtensionPinOverlay from '@/Components/UI/ExtensionPinOverlay'


export default {
    components: {
        //JetAuthenticationCard,
        JetAuthenticationCardLogo,
        JetButton,
        JetInput,
        JetCheckbox,
        JetLabel,
        //JetValidationErrors,
        JetSectionBorder,
        JetBanner,
        ArrowRightIcon,
        ArrowLeftIcon,
        LockClosedIcon,
        EnvelopeIcon,
        XCircleIcon,
        Spinner,
        ExtensionPinOverlay,
        code_attempts: 0,
        max_code_attempts: false
    },

    props: {
        canResetPassword: Boolean,
        status: String,
        request_email: String,
        integration_type: String,

        google_id: {
            type: String,
            default: null
        },
        google_email: {
            type: String,
            default: null
        },
        join_team: {
            type: Number,
            default: null
        },
        domain: {
            type: String,
            default: null
        },
        is_personal: {
            type: Boolean,
            default: false
        },
        google_name: {
            type: String,
            default: null
        },
        google_avatar: {
            type: String,
            default: null
        },
        login_landing: {
            type: String,
            default: null
        },
        invitation: {
            type: Object,
            default: null
        },
        invitation_existing_user: {
            type: Object,
            default: null
        },
        invitation_link: {
            type: Number,
            default: null
        },
        invitation_link_team_name: {
            type: String,
            default: null
        }

    },

    created() {

        this.moment = moment;
        this.form.timezone = this.moment.tz.guess()

        if (this.google_id) {

            this.user_checked = true
            this.need_code_validation = false
            this.form.google_id = this.google_id

            if (this.google_email) {
                this.form.email = this.google_email
            }

            if (this.join_team) {
                this.form.join_team = this.join_team
                this.is_join = true
            } else {
                this.is_signup = true
            }

            if (this.domain) {
                this.form.domain = this.domain
            }
            if (this.is_personal) {
                this.form.is_personal = this.is_personal
            }
            if (this.google_name) {
                this.form.google_name = this.google_name
            }
            if (this.google_avatar) {
                this.form.google_avatar = this.google_avatar
            }

        } else if (this.$page.props.user_email) {
            this.form.email = this.$page.props.user_email
            this.testEmail()
        } else if (this.request_email) {
            this.form.email = this.request_email
            this.testEmail()
        }

        if (this.invitation) {
            this.is_join = true
            this.form.join_team = this.invitation.team_id
            this.form.email = this.invitation.email
            this.user_checked = true
            this.need_code_validation = false
            this.is_signup = false
            this.is_login = false
            this.is_sso = false
            this.sso_redirect = null
            this.step = 2
            this.form.is_invitemail = true
            this.form.invitation = this.invitation
            this.form.invitation_existing_user = this.invitation_existing_user
        } else if (this.invitation_link) {
            this.is_join = true
            this.form.join_team = this.invitation_link
            this.is_signup = false
            this.is_login = false
            this.is_sso = false
            this.sso_redirect = null
        }
    },

    data() {
        return {
            form: this.$inertia.form({
                email: '',
                password: '',
                code: '',
                timezone: '',
                remember: true,
                join_team: null,
                is_personal: false,
                domain: null,
                google_id: null,
                google_name: null,
                google_avatar: null,
                type: 'signin',
                is_invitemail: false,
                invitation: null,
                invitation_link: this.invitation_link,
                invitation_existing_user: null
            }),
            // is_oauth: this.$page.props.oauth === 'oauth',
            // sso_team: false,

            user_checked: false,
            user_error: null,
            is_signup: false,
            is_sso: false,
            is_join: false,
            is_login: false,
            need_code_validation: true,

            sso_redirect: null,

            step: 1,
            timeout: Object,
            buffer: 400,
            lastTypeMoment: 0,
            testing_email: false,
            testing_code: false,
            seconds_left: 60,
            resendInterval: null,
            code_disabled: false,


        }
    },

    mounted() {
        if (this.login_landing != 'extension' && window.google) {
            window.google.accounts.id.prompt();
        }
    },

    methods: {
        closePinOverlay() {
            if (window.google) {
                window.google.accounts.id.prompt();
            }
        },
        changeEmailValue(value) {

            this.user_checked = false
            this.sso_redirect = null
            this.user_error = null

            if (this.validateEmail(value)) {

                this.form.email = value

                let now = new Date().getTime();
                if (now - this.lastTypeMoment < this.buffer) {
                    clearTimeout(this.timeout);
                }
                if (this.testing_email) {
                    this.cancel();
                }
                this.timeout = setTimeout(function () { this.testEmail() }.bind(this), this.buffer);
                this.lastTypeMoment = now;

            }
        },
        // emailChanged() {
        // console.log('emailChanged')
        // this.user_checked = false
        // this.is_not_user = false
        // },
        cancel() {
            cancel();
        },

        testEmail() {

            // if (!this.form.email || !this.validateEmail(this.form.email)) {
            //     this.show_info_email = false;
            //     this.sso_redirect = null;
            //     return;
            // }

            this.testing_email = true
            var self = this

            let params = {
                email: this.form.email
            };
            if (this.invitation_link) {
                params.invitation_link = this.invitation_link
            }
            let url = this.$page.props.api_url + '/v1/team/checkmail'
            axios.post(url, params, {
                cancelToken: new CancelToken(function executor(c) {
                    cancel = c;
                })
            })
                .then(response => {
                    // console.log("response", response.data);
                    this.need_code_validation = false
                    this.is_join = false
                    this.is_login = false
                    this.is_signup = false
                    this.is_sso = false
                    this.sso_redirect = null
                    this.form.is_personal = false

                    if (this.invitation_link) {
                        if (response.data.valid_domains) {
                            if (response.data.user_exists) {
                                this.user_checked = false
                                this.user_error = response.data.user_exists
                            } else if (response.data.error) {
                                this.user_checked = false
                                this.user_error = response.data.error
                            } else {
                                this.user_checked = true
                                this.form.join_team = response.data.join_team
                                this.is_join = true
                            }
                        }
                    } else {

                        if (response.data.is_personal) {
                            this.form.is_personal = response.data.is_personal
                        }

                        if (response.data.sso_redirect) {
                            this.sso_redirect = response.data.sso_redirect
                            this.is_sso = true
                        } else if (response.data.join_team) {
                            this.form.join_team = response.data.join_team
                            this.is_join = true
                        } else if (response.data.error) {
                            if (response.data.error == 'user not registered') {
                                this.is_signup = true
                            }
                        } else {
                            this.is_login = true
                        }

                        this.user_checked = true
                    }


                    this.testing_email = false
                })
                .catch(thrown => {
                    if (axios.isCancel(thrown)) {
                        //ok
                    } else {
                        console.error(thrown)
                    }
                    this.testing_email = false;
                });
        },

        // testEmail_old() {
        //     if (!this.email_valid || this.testing_email) {
        //         return
        //     }
        //     var params = {
        //         email: this.form.email,
        //     };
        //     let url = this.$page.props.api_url + '/v1/team/sso'
        //     this.testing_email = true

        //     axios.post(url, params)
        //         .then(response => {
        //             console.log("response", response.data);
        //             if (response.data.sso_redirect) {
        //                 this.sso_redirect = response.data.sso_redirect
        //             } else if (response.data.error) {
        //                 if (response.data.error == 'user not registered') {
        //                     this.is_not_user = true
        //                     this.is_signup = true
        //                     console.log("is_signup", this.is_signup)
        //                 }
        //             }
        //             // this.sso_redirect = 'https://app.birdie.so/login/BXAviDa1jAmfk3uCTE5G'
        //             this.user_checked = true
        //             this.testing_email = false
        //             if (!this.is_not_user && !this.sso_redirect) {
        //                 setTimeout(() => {
        //                     this.$refs.codeInput.focus()
        //                 }, 200)
        //                 this.timer()
        //             }
        //         })
        //         .catch(e => {
        //             console.error(e);
        //             this.testing_email = false
        //         });
        // },
        clickButton: function () {
            // console.log("clickButton", this.user_checked, this.sso_redirect, this.need_code_validation, this.code_valid)
            if (!this.user_checked) {
                return
            }
            if (this.user_checked && this.need_code_validation && !this.code_valid) {
                return
            }

            this.step = 2

            if (this.invitation && this.is_join) {
                this.submitSignup()
            }
            else if (this.sso_redirect) {
                window.location.href = this.sso_redirect
            } else if (this.need_code_validation && this.code_valid) {
                if (this.is_join || this.is_signup) {
                    this.submitSignup()
                } else {
                    this.submitLogin()
                }
            } else if (!this.form.google_id) {
                this.need_code_validation = true
                this.form.code = ''
                this.timer()
                // if (this.form.code == '') {
                setTimeout(() => {
                    this.$refs.codeInput.focus()
                }, 200)

                // }

                // this.submitLogin()
            } else {
                // this should not occur
                console.error("Known user with a google_id should be already authenticated")
            }
        },

        backToEmail: function () {
            this.user_checked = false
            this.is_signup = false
            this.is_sso = false
            this.is_login = false
            this.user_error = null
            this.testing_email = false
            this.testing_code = false
            this.sso_redirect = null
            if (this.invitation_link) {
                this.is_join = true
                this.form.join_team = this.invitation_link
            } else {
                this.is_join = false
                this.form.join_team = null
            }
            this.need_code_validation = true
            this.code_disabled = false
            this.code_attempts = 0
            this.max_code_attempts = false
            this.form.email = ''
            this.form.password = ''
            this.form.code = ''
            this.form.google_id = null

            this.form.is_personal = false
            this.form.domain = null
            this.form.google_name = null
            this.form.google_avatar = null
            this.$page.props.errors = {}
            this.seconds_left = 60
            this.step = 1
            clearInterval(this.resendInterval)
            setTimeout(() => {
                this.$refs.emailInput.focus()
            }, 200)
        },
        passwordChanged() {
            this.$page.props.errors = {}
        },
        codeChanged() {
            this.$page.props.errors = {}
        },


        createCode() {
            this.code_attempts = 0
            this.max_code_attempts = false
            this.$page.props.errors = {}
            this.code_disabled = false
            axios.post(this.$page.props.api_url + '/v1/user/logincode', {
                email: this.form.email,
                is_signup: this.is_signup,
                is_join: this.is_join
            })
                .then(response => {
                    setTimeout(() => {
                        this.$refs.codeInput.focus()
                    }, 200)
                }).catch(e => {
                    console.error(e);
                });
        },

        timer() {
            clearInterval(this.resendInterval)
            this.createCode()
            this.seconds_left = 60
            this.resendInterval = setInterval(() => {
                this.seconds_left--
                if (this.seconds_left == 0) {
                    clearInterval(this.resendInterval)
                }
            }, 1000)
        },
        submitSignup() {
            this.form.type = 'signup'
            this.form
                .transform(data => ({
                    ...data,
                    password: this.form.password ? this.form.password : this.form.code,
                    remember: this.form.remember ? 'on' : '',
                    _token: this.$page.props.csrf_token
                }))
                .post(route('signup.finalize'), {
                    errorBag: 'submitSignup',
                    preserveScroll: true,
                    onStart: () => {
                        this.code_disabled = true
                    },
                    onFinish: () => {
                        this.form.reset('password')
                        this.code_disabled = false
                    },
                    onError: (error) => {
                        // console.log("onError", error)
                        // Handle both Inertia validation errors and JSON error responses
                        if (error.code) {
                            // Handle JSON error response
                            this.$page.props.errors = [error.code]
                        } else {
                            // Handle regular Inertia validation errors
                            if (this.form.errors.email) {
                                this.form.reset('email')
                                this.backToEmail()
                            }
                        }
                    }
                })
        },
        submitLogin() {
            this.form.type = 'signin'
            this.code_attempts++
            this.form
                .transform(data => ({
                    ...data,
                    password: this.form.password ? this.form.password : this.form.code,
                    remember: this.form.remember ? 'on' : '',
                    _token: this.$page.props.csrf_token,
                    code_attempts: this.code_attempts
                }))
                .post(this.route('login'), {
                    onStart: () => {
                        this.code_disabled = true
                    },
                    onFinish: (response) => {
                        this.form.reset('password')
                        // this.code_disabled = false
                        // this.form.reset('code')
                        // console.log("onFinish")
                        // console.log("response", response)
                    },
                    onError: (error) => {
                        if (this.code_attempts >= 5) {
                            this.form.code = ''
                            this.max_code_attempts = true
                        } else {
                            this.code_disabled = false
                        }
                        console.log("onError", error)
                    }
                })
            // }
        },
        validateNotempty: function (value) {
            var re = /^\s*\S+.*/;
            return re.test(value);
        },
        validateEmail: function (value) {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(value);
        },
        errorString: function () {
            var messages = []
            const entries = Object.entries(this.errors);
            entries.forEach(([key, value]) => {
                messages.push(value)
            });
            return messages.join(', ')
        }
    },
    computed: {
        // is_signup() {
        //     return this.force_signup || (this.is_not_user && this.user_checked)
        // },
        button_disabled() {
            if (!this.email_valid || this.testing_email || this.form.processing || this.form.google_id) {
                //console.log("a", this.email_valid, this.testing_email, this.form.processing)
                return true
            } else if (!(this.is_join || this.is_sso || this.is_signup || this.is_login)) {
                //console.log("b", this.is_join, this.is_sso, this.is_signup, this.is_login)
                return true
            } else if (this.need_code_validation && (!this.code_valid || this.testing_code)) {
                //console.log("c", this.code_valid, this.testing_code)
                return true
            } else if (this.max_code_attempts) {
                return true
            }

            // if (this.testing_email || !this.user_checked) {
            //     return true
            // } else if (this.sso_redirect || this.is_signup) {
            //     return false
            // } else if (!this.code_valid || this.form.processing) {
            //     return true
            // }
            return false
        },
        email_disabled() {
            return this.user_checked && this.step == 2 && (this.is_join || this.is_signup || this.is_login || this.is_sso)
        },
        email_valid() {
            return this.validateEmail(this.form.email)
        },
        code_valid() {
            return /^[0-9]{6}$/.test(this.form.code)
        },
        errors() {
            return this.$page.props.errors
        },
        hasErrors() {
            return Object.keys(this.errors).length > 0;
        },

    },
    watch: {
        'form.email': {
            handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.changeEmailValue(newVal)
                }
            }
        }
    }
}
</script>

<style scoped>
/* Add these transition classes */
.fade-enter-active,
.fade-leave-active {
    transition: all 0.3s ease-in-out;
    max-height: 70px;
    /* Adjust based on your content */
    opacity: 1;
    margin-top: 1.75rem;
    /* mt-6 */
    overflow: hidden;
    /* mb-4 */
}

.fade2-enter-active,
.fade2-leave-active {
    transition: all 0.3s ease-in-out;
    max-height: 111px;
    /* Adjust based on your content */
    opacity: 1;
    /* mt-6 */
    overflow: hidden;
    /* mb-4 */
}

.fade-enter-from,
.fade-leave-to,
.fade2-enter-from,
.fade2-leave-to {
    opacity: 0;
    max-height: 0;
    margin-top: 0;
    overflow: hidden;
}
</style>
